import {Autocomplete, TextField, TextFieldProps} from '@mui/material';
import isNil from 'lodash/isNil';

type Props = Pick<
  TextFieldProps,
  | 'size'
  | 'disabled'
  | 'fullWidth'
  | 'label'
  | 'error'
  | 'helperText'
  | 'InputProps'
  | 'sx'
> & {
  value?: number;
  onChange?: (value?: number | null) => void;
};

export const TypeSelect = ({
  value,
  disabled,
  fullWidth,
  size,
  onChange,
  ...props
}: Props) => {
  const nullValue = 0;

  const options = [
    {
      id: 0,
      name: 'All',
    },
    {
      id: 1,
      name: 'Assets',
    },
    {
      id: 2,
      name: 'Employees',
    },
  ];

  const selectedOptionId = isNil(value) ? nullValue : value;
  const selectedOption = options.find((i) => i.id === selectedOptionId) ?? null;

  return disabled ? (
    <TextField
      {...props}
      value={options.find((i) => i.id === value)?.name ?? ''}
      disabled={disabled}
      fullWidth={fullWidth}
      size={size}
    />
  ) : (
    <Autocomplete
      value={selectedOption ?? null}
      disabled={disabled}
      fullWidth={fullWidth}
      options={options}
      size={size}
      disableClearable={selectedOptionId === nullValue}
      isOptionEqualToValue={(o, v) => o.id === v.id}
      getOptionLabel={(o) => o.name ?? ''}
      filterOptions={(options) => options}
      renderInput={(params) => (
        <TextField label="Type" {...props} {...params} />
      )}
      renderOption={(props, option) => {
        return (
          <li {...props} key={option.id}>
            {option.name}
          </li>
        );
      }}
      onChange={(_, option) => {
        const v =
          !option || isNil(option.id) || option.id === nullValue
            ? 0
            : option.id;
        onChange?.(v);
      }}
    />
  );
};
